/** Wallets where the API returns many zero-balance rows — table shows only rows with funds (else empty art). */
export const P2P_SWAP_EARNING_WALLET_TYPES = ["p2p", "swap", "earning"];

function finiteOrZero(raw) {
  const n = typeof raw === "number" ? raw : parseFloat(raw);
  return Number.isFinite(n) ? n : 0;
}

/** Same behavior as inlined useCallbacks on WalletPage portfolio helpers */
export function preferredAmountOrZero(portfolioPreferredAmount, p) {
  return finiteOrZero(portfolioPreferredAmount(p));
}

export function usdtEstimateOrZero(portfolioUsdtEstimate, p) {
  return finiteOrZero(portfolioUsdtEstimate(p));
}

/** Parse API decimal / `$numberDecimal` for spot PnL fields. */
export function parseSpotPnlValue(raw) {
  if (raw == null || raw === "") return null;
  if (typeof raw === "object" && raw !== null && "$numberDecimal" in raw) {
    const n = parseFloat(raw.$numberDecimal);
    return Number.isFinite(n) ? n : null;
  }
  const n = typeof raw === "number" ? raw : parseFloat(raw);
  return Number.isFinite(n) ? n : null;
}

export function spotPnlColorClass(n) {
  if (n == null || n === 0) return "cmp-text-muted";
  return n > 0 ? "cmp-text-success" : "cmp-text-danger";
}

export function formatSpotPnl(n, { asset = "USDT", decimals = 2 } = {}) {
  if (n == null) return "—";
  return `${n >= 0 ? "+" : ""}${n.toFixed(decimals)} ${asset}`;
}

/** Map `GET /spot/v1/me/pnl` payload to display-friendly numbers. */
export function normalizeSpotPnlSummary(data) {
  if (!data || typeof data !== "object") return null;
  return {
    asset: data.valuation_asset || "USDT",
    period: data.period || "all",
    realizedPnl: parseSpotPnlValue(data.realized_pnl_usdt),
    unrealizedPnl: parseSpotPnlValue(data.unrealized_pnl_usdt),
    totalPnl: parseSpotPnlValue(data.total_pnl_usdt),
    realizedPnlAllTime: parseSpotPnlValue(data.realized_pnl_all_time_usdt),
    totalFees: parseSpotPnlValue(data.total_fees_usdt),
    totalTds: parseSpotPnlValue(data.total_tds_usdt),
    tradeCount: data.trade_count ?? null,
    assets: Array.isArray(data.assets) ? data.assets : [],
  };
}
